/** Canonical public URLs for ImPACTS organization and the PECC Support Tool. */
export const IMPACTS_ORG_URL = 'https://www.impactscollaborative.com/';
export const PECC_TOOL_URL = 'https://peccsupporttool.com/';
export const PECC_TOOL_ACCOUNT_URL = 'https://peccsupporttool.com/account';
export const IMPACTS_CONTACT_EMAIL = 'impactscollaborative@gmail.com';
